import { http } from './config'

export default {
  getAllPalletizedProducts: () => {
    return http.get('palletized_products')
  },

  getAllPalletizedProductsByBayID: (loadID, bayID) => {
    return http.get('palletized_products/?load_id=' + loadID + '&bay_id=' + bayID)
  },

  getPalletizedProductsByLoadID: (loadID) => {
    return http.get('palletized_products/by_load_id/' + loadID)
  },
}
